var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "59.648px",
    height: "35.880px",
    viewBox: "0 -1225.1 3295.4 1982.4",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MJX-7-TEX-N-22CA",
    d: "M146 472Q146 479 152 485T166 492Q171 492 189 475T279 386L386 279L495 386Q598 492 608 492Q615 492 628 479V21Q615 8 608 8Q599 8 495 115L386 221L279 115Q204 40 188 24T166 8Q159 8 153 14T146 28Q146 37 253 144L359 250L253 357Q146 464 146 472ZM588 77V424L499 337L415 250L588 77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "MJX-7-TEX-I-1D711",
    d: "M92 210Q92 176 106 149T142 108T185 85T220 72L235 70L237 71L250 112Q268 170 283 211T322 299T370 375T429 423T502 442Q547 442 582 410T618 302Q618 224 575 152T457 35T299 -10Q273 -10 273 -12L266 -48Q260 -83 252 -125T241 -179Q236 -203 215 -212Q204 -218 190 -218Q159 -215 159 -185Q159 -175 214 -2L209 0Q204 2 195 5T173 14T147 28T120 46T94 71T71 103T56 142T50 190Q50 238 76 311T149 431H162Q183 431 183 423Q183 417 175 409Q134 361 114 300T92 210ZM574 278Q574 320 550 344T486 369Q437 369 394 329T323 218Q309 184 295 109L286 64Q304 62 306 62Q423 62 498 131T574 278Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000000",
    fill: "#000000",
    strokeWidth: 0,
    transform: "scale(1,-1)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-mml-node": "math"
  }, /*#__PURE__*/React.createElement("g", {
    "data-mml-node": "mstyle",
    transform: "scale(2.49)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-mml-node": "TeXAtom",
    "data-mjx-texclass": "ORD"
  }, /*#__PURE__*/React.createElement("g", {
    "data-mml-node": "msub"
  }, /*#__PURE__*/React.createElement("g", {
    "data-mml-node": "mo"
  }, /*#__PURE__*/React.createElement("use", {
    "data-c": "22CA",
    xlinkHref: "#MJX-7-TEX-N-22CA"
  })), /*#__PURE__*/React.createElement("g", {
    "data-mml-node": "TeXAtom",
    transform: "translate(811,-150) scale(0.707)",
    "data-mjx-texclass": "ORD"
  }, /*#__PURE__*/React.createElement("g", {
    "data-mml-node": "mi"
  }, /*#__PURE__*/React.createElement("use", {
    "data-c": "1D711",
    xlinkHref: "#MJX-7-TEX-I-1D711"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.dee6a936d56f9f1a31db262101de425e.svg";
export { ForwardRef as ReactComponent };